import { TextInput } from '@ally/forms'
import { Box, upToMd } from '@ally/metronome-ui'
import dayjs from 'dayjs'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import React from 'react'
import styled from 'styled-components'

dayjs.extend(isSameOrBefore)

const StyledDateBox = styled(Box)`
  span {
    white-space: nowrap;
  }
`

export const BeneficiaryDobField: React.FC<{
  onDateChange: (e: React.BaseSyntheticEvent) => void
  checkBackspace: (e: React.KeyboardEvent) => void
}> = ({ onDateChange, checkBackspace }) => {
  const isValidDate = (date: string): boolean => {
    return (
      dayjs(date, 'MM/DD/YYYY').format('MM/DD/YYYY') === date &&
      dayjs(date, 'MM/DD/YYYY', true).isValid()
    )
  }

  const validateDob = (val: string): string => {
    if (!val || !isValidDate(val)) {
      return 'Enter a valid birth date in this format: mm/dd/yyyy.'
    }
    if (dayjs(val).isSameOrBefore('12/31/1840')) return 'Enter a valid date.'
    if (dayjs(val).isAfter(dayjs()))
      return `The birth date can't be a future date. Enter a valid date of birth.`
    // istanbul ignore next // we can remove this ignore once we apply an integration testing for this form
    return ''
  }

  return (
    <StyledDateBox width={upToMd('88%', '50%')} mb="md">
      <TextInput
        isPrivate
        labelContent="Date of Birth"
        name="dateOfBirth"
        inputType="text"
        validate={validateDob}
        placeholder="   /    /"
        contextualHelp={{
          variant: 'inline',
          content: 'mm/dd/yyyy',
        }}
        onChange={onDateChange}
        onKeyDown={checkBackspace}
      />
    </StyledDateBox>
  )
}
